import React from "react";
import { dispatch } from '@rematch/core';
import { Grid, Card, Icon } from 'semantic-ui-react'
import "react-datepicker/dist/react-datepicker.css";
import GanttChart from '../../../../common/GanttChart';
import { withRouter } from 'react-router-dom';
import BreadCrumbs from './../../Drive/cards/Breadcrumbs'
import ArrangementPane from './ArrangementPane';
import LoadingComponent from '../../../../common/LoadingComponent';
import moment from 'moment';
class Timeline extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            projectDetails: null,
            loader: true
        }
    }
    async componentWillMount() {
        dispatch.app.setRouteParams(this.props.match.params)
        this.setState({ loader: true })
        let selectedDataById = this.props.selectedDataById;
        let objValidation = Object.entries(selectedDataById).length === 0 && selectedDataById.constructor === Object
        if (objValidation) {
            await dispatch.initiatives.getInDesignInitiativeDetailsById(this.props.match.params.initiativeId);
        }
        dispatch.initiatives.setTabName("Timeline");
        this.setState({
            projectDetails: {
                startDate: this.props.selectedDataById.startDate,
                endDate: this.props.selectedDataById.endDate,
                activities: this.props.selectedDataById.activities ? this.props.selectedDataById.activities : [],
                workingDays: this.props.selectedDataById.workingDays
            }, loader: false
        })

    }

    render() {
        let windowDimension = this.props.componentDesignerDimension;
        let designerHeight = (windowDimension.windowHeight - windowDimension.height) - 170

        return (this.state.projectDetails &&
            <div ref={this.parentRef}
                className="containerBox overflow-hide"
                style={{ width: windowDimension.width ? (windowDimension.width - 40) : 300 }}>
                <ArrangementPane {...this.props} />
                <BreadCrumbs {...this.props} />
                <LoadingComponent message="Generating timeline..." active={this.state.loader} />
                <Grid className="initiative_overall_progress w_100" >
                    <Grid.Row className="pad_0">
                        <Card className="progressDetail">
                            <Card.Content className="header_content">
                                <Card.Header className="pad_10">
                                    <strong>  Timeline/Holidays  </strong>

                                </Card.Header>
                            </Card.Content>
                            <Card.Content className="Detailed_content"  >
                                {this.state.projectDetails && <GanttChart
                                    timeZone={this.props.selectedOrganisation.timeZone}
                                    projectDetails={this.state.projectDetails}
                                    windowHeight={designerHeight}
                                    windowDimension={windowDimension}
                                    activeIndex={0}
                                    projectStartDate={moment(this.props.selectedDataById.startDate).format('MM-DD-YYYY')}
                                    projectEndDate={moment(this.props.selectedDataById.endDate).format('MM-DD-YYYY')}
                                />}
                            </Card.Content>
                        </Card >
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}





export default withRouter(Timeline);
